import { render } from "./TicketStatus.vue?vue&type=template&id=c90dd610&scoped=true"
import script from "./TicketStatus.vue?vue&type=script&lang=js"
export * from "./TicketStatus.vue?vue&type=script&lang=js"

import "./TicketStatus.vue?vue&type=style&index=0&id=c90dd610&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c90dd610"]])

export default __exports__